import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=5ceef619&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=5ceef619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceef619",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ceef619')) {
      api.createRecord('5ceef619', component.options)
    } else {
      api.reload('5ceef619', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=5ceef619&scoped=true&", function () {
      api.rerender('5ceef619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/core/SideMenu.vue"
export default component.exports